/**
 * Clears the layers if the mission has been reset.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.mission - The mission object.
 * @param {object} arg.geoJSONTakeOffPointLayer - The geoJSON layer where the take off point is painted.
 * @param {object} arg.geoJSONLandingPointLayer - The geoJSON layer where the landing point is painted.
 * @param {object} arg.drawnItems - The geoJSON layer where the mission geometry is painted.
 * @param {object} arg.geoJSONRpaPathLayer - The geoJSON layer where the RPA path is painted.
 * @param {object} arg.geoJSONWaypointListLayer - The geoJSON layer where the waypoitns are painted.
 */
const clearMissionMap = ({
  mission,
  geoJSONTakeOffPointLayer,
  geoJSONLandingPointLayer,
  drawnItems,
  geoJSONRpaPathLayer,
  geoJSONWaypointListLayer
}) => {
  if (mission.flightPlan) {
    const myFlightPlanKeys = Object.keys(mission.flightPlan);
    const clearedKeys = ['takeOffPoint', 'landingPoint', 'missionArea', 'missionAxis'];
    const myFlightPlanKeysFiltered = myFlightPlanKeys.filter(word => clearedKeys.includes(word));
    if (myFlightPlanKeysFiltered.length === 0) {
      geoJSONTakeOffPointLayer.clearLayers();
      geoJSONLandingPointLayer.clearLayers();
      drawnItems.clearLayers();
      geoJSONRpaPathLayer.clearLayers();
      geoJSONWaypointListLayer.clearLayers();
    }
  }
};

export default clearMissionMap;
